import gql from "graphql-tag";

export const UPDATE_AGREEMENT_USER_ROLES = gql`
	mutation UpdateAgreementUserRoles($input: UserRoleRequestUpdateInput!) {
		UpdateAgreementUserRoles(input: $input)
	}
`;

export const UPDATE_AGREEMENT_ASSIGNEE = gql`
	mutation UpdateAgreementAssignee($agreementId: String!, $userId: String!, $isAssignee: Boolean!) {
		UpdateAgreementAssignee(agreementId: $agreementId, userId: $userId, isAssignee: $isAssignee)
	}
`;

export const GET_AGREEMENT_USER_ROLES = gql`
	query GetAgreementUserRoles($id: ID!) {
		GetAgreementUserRoles(agreementId: $id) {
			node {
				isDeleted
				firstName
				lastName
				id
			}
			role
			isAssignee
		}
	}
`;
